import React from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/Home'
import About from './components/About'
import BlogsPage from './pages/BlogsPage'
import BlogPostPage from './pages/BlogPostPage'
import Contact from './components/Contact'
import PropertyDetail from './components/PropertyDetail'
import Footer from './components/Footer'
import FloatingCTA from './components/FloatingCTA'
import WhatsAppButton from './components/WhatsAppButton'
import LeadPopup from './components/LeadPopup'
import { PopupProvider } from './context/PopupContext'
import { initErrorHandling } from './utils/errorHandler'

// ScrollToTop component to reset scroll on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

import SEO from './components/SEO'

function App() {
  React.useEffect(() => {
    initErrorHandling();
  }, []);

  return (
    <PopupProvider>
      <Router>
        <ScrollToTop />
        <SEO
          title="Singh's Best Buy | Gurgaon's Trusted Real Estate Aggregators"
          description="Explore exclusive Gurgaon luxury projects with Singh's Best Buy — verified, research-backed, and curated for high ROI. Ready-to-move, low-density, premium homes."
          keywords="Real Estate Gurgaon, Luxury Homes, Property Investment, Singh's Best Buy"
          url="https://www.singhsbestbuy.com"
        />
        <div className="page-wrapper">
          <div className="global-styles w-embed">
            {/* Global Styles Embed (kept mostly for Webflow legacy if needed, but Tailwind handles most) */}
            <style dangerouslySetInnerHTML={{
              __html: `
              body { overflow-x: hidden; }
            `}} />
          </div>

          <Navbar />

          <main className="main-wrapper min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/blogs" element={<BlogsPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/property/:id" element={<PropertyDetail />} />
              <Route path="*" element={<Home />} /> {/* Fallback to Home */}
            </Routes>
          </main>

          <Footer />
          <div className="flex flex-col items-end fixed bottom-6 right-6 z-50 gap-4 pointer-events-none">
            <div className="pointer-events-auto">
              <WhatsAppButton />
            </div>
            <div className="pointer-events-auto">
              <FloatingCTA />
            </div>
          </div>
          <LeadPopup />
        </div>
      </Router>
    </PopupProvider>
  )
}

export default App
